/*Menu*/

/*Menu*/

.links a {
	display: grid;
	grid-template-columns: 1fr 20px;
	grid-template-rows: 1fr;
	color: #000;
	gap: 0px 0px;
	grid-template-areas: '. .';
	padding: 10px;
	text-align: left;
	transition: color ease-out 220ms;
}

.links a:hover {
	color: var(--app-accent-color);
}

.menu-dialog {
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	border: 0px;
	background: rgba(0, 0, 0, 0);
	z-index: 100;
	padding: 0px;
}

.menu-dialog[open] {
	animation: showDialog 220ms ease-out normal;
	-webkit-animation: showDialog 220ms ease-out normal;
}

.menu-dialog[data-hide] {
	animation: hideDialog 220ms ease-out normal;
	-webkit-animation: hideDialog 220ms ease-out normal;
}

.menu {
	position: absolute;
	top: 0;
	right: 0px;
	font-family: var(--content-font-family) !important;
	margin-top: calc(var(--top-bar-height) + 10px);
	margin-right: 10px;
	min-height: 40px;
	width: 250px;
	border: 1px solid #c3c3c3;
	border-radius: 8px;
	background: #fff;
	overflow: hidden;
}

.menu > button,
.menu > a,
.menu > .language {
	display: flex;
	cursor: pointer;
	width: 100%;
	border: 0px;
	min-height: 40px;
	justify-content: space-between;
	align-items: center;
	background: transparent;
	padding: 0px 10px;
	color: #000;
	transition: color ease-out 220ms;
}

.menu section {
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid #c3c3c3;
}

.menu > button:not(:last-child),
.menu > a:not(:last-child),
.menu > div:not(:last-child) {
	border-bottom: 1px solid #c3c3c3;
}

.menu > a > span:last-of-type > div,
.menu > button > span:last-of-type > div {
	transition: background-color ease-out 220ms;
}

.menu span,
.menu a {
	font-family: var(--content-font-family) !important;
	font-size: 0.9rem;
}

.menu button,
.menu a {
	transition: font-weight ease-out 220ms;
}
.menu button:hover,
.menu a:hover {
	font-weight: bold;
}

.menu > button:hover svg,
.menu > a:hover svg {
	font-weight: bold;
}

.menu > a:hover > span:last-of-type > div,
.menu > button:hover > span:last-of-type > div {
	background-color: var(--topbar-buttons-stroke-hover) !important;
}

.menu .links a {
	display: grid;
	grid-template-columns: 1fr 20px;
	grid-template-rows: 1fr;
	color: #000;
	gap: 0px 0px;
	grid-template-areas: '. .';
	padding: 10px;
	text-align: left;
	transition: color ease-out 220ms;
}

.menu .links a:hover {
	color: var(--app-accent-color);
}

.menu > div button:hover > div {
	background-color: var(--app-accent-color) !important;
}

.menu > .language {
	padding: 0px 0px;
}

.menu .language > :first-child {
	padding-left: 10px;
}

.menu .language > :last-child {
	padding-right: 10px;
}

.menu > a {
	width: unset;
}

.menu > button,
.menu > a {
	cursor: pointer;
}

.menu > button:disabled {
	opacity: 0.5;
}

.menu > button > :last-child,
.menu > a > :last-child {
	width: 24px;
	height: 24px;
}

.menu .font-button {
	display: grid;
	grid-auto-columns: 1fr;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr;
	gap: 0px 0px;
	grid-template-areas: '. . .';
	min-height: 40px;
	padding: 0px 10px;
}

.menu .font-button span {
	display: flex;
	justify-content: center;
	align-items: center;
}

.menu .font-button button {
	height: 32px;
	border: 0px;
	cursor: pointer;
	background: transparent;
	margin-top: auto;
	margin-bottom: auto;
}

.menu .font-button button:first-of-type {
	margin-right: auto;
}

.menu .font-button button:last-of-type {
	margin-left: auto;
}

.menu .legal {
	border-top: 1px solid #c3c3c3;
	font-size: 0.7rem;
	padding: 5px;
	font-family: var(--content-font-family);
}

.menu .legal > div {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 20px;
	gap: 8px 10px;
	grid-template-areas:
		'copyright copyright'
		'. .';
}

.menu .legal > div > :first-child {
	grid-area: copyright;
	line-height: 1.5;
}

.menu .legal > div > div,
.menu .legal a {
	color: gray;
	transition: color ease-out 220ms;
}

.menu .legal a:hover {
	color: var(--app-accent-color);
}

@keyframes showDialog {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@-webkit-keyframes showDialog {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes hideDialog {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}

@-webkit-keyframes hideDialog {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}
